package com.fantasytenis.web.config

import kotlin.js.json

/**
 * Environment configuration injected at build time via webpack DefinePlugin.
 *
 * - Production build (`jsBrowserProductionWebpack`): Uses production URLs
 * - Development build (`jsBrowserDevelopmentRun`): Uses localhost URLs
 */
object Environment {
    val apiBaseUrl: String
        get() = js("process.env.API_BASE_URL").unsafeCast<String?>()
            ?: "http://localhost:50040/v2/"

    val realtimeUrl: String
        get() = js("process.env.REALTIME_URL").unsafeCast<String?>()
            ?: "http://localhost:50070"

    val isProduction: Boolean
        get() = js("process.env.IS_PRODUCTION").unsafeCast<Boolean?>()
            ?: false
}
